import { Injectable } from '@angular/core';
import { injectMutation } from '@tanstack/angular-query-experimental';
import { lastValueFrom } from 'rxjs';
import { BaseApiService } from './base.api.service';

@Injectable({ providedIn: 'root' })
export class CgvService extends BaseApiService {

  /** Accepter les CGV / Politique de confidentialité */
  acceptCgv = injectMutation(() => ({
    mutationFn: async (args: { accepted: boolean }) => {
      try {
        return await lastValueFrom(
          this.httpClient.post(
            `${this.baseUrl}/connect/acceptCGV`,
            { accepted: args.accepted },
            {
              withCredentials: true,
            }
          )
        );
      } catch (error: any) {
        this.handleError(error);
        throw error;
      }
    },
    onSuccess: () => {
      // Invalider le cache de l'utilisateur pour recharger ses infos
      this.queryClient.invalidateQueries({ queryKey: ['myuserinfo'] });
    },
  }));
}
